const isEnter = (
  e: React.KeyboardEvent<HTMLIonTextareaElement | HTMLIonInputElement>
): boolean => {
  const { key, altKey, ctrlKey, shiftKey } = e;
  return (
    key === 'Enter' &&
    altKey === false &&
    ctrlKey === false &&
    shiftKey === false
  );
};

const blurOnEnter = async (
  e: React.KeyboardEvent<HTMLIonTextareaElement | HTMLIonInputElement>
): Promise<void> => {
  if (isEnter(e)) {
    const el = await e.currentTarget.getInputElement();
    el.blur();
  }
};

export { isEnter, blurOnEnter };
